import React from "react";

import { Customer } from "@/types/pledgeService";

import styles from "./CustomerDetails.module.css";

interface Props {
  details: Customer;
  variant?: "default" | "customerConsent";
  isWakil?: boolean;
  customerName?: string;
}

const CustomerDetails: React.FC<Props> = ({ details, variant, isWakil = false, customerName }) => {
  const getAddress = (
    address1: string | null,
    address2: string | null,
    address3: string | null,
  ): string => {
    return [address1, address2, address3].filter(Boolean)?.join(",");
  };

  return (
    <div
      className={`${styles.customerDetails} ${
        variant === "customerConsent" ? styles.customerConsent : ""
      }`}
    >
      <p className={styles.idNumber}>{`${details?.id_number} (${details?.id_type})`}</p>

      <p className={styles.customerName}>
        {isWakil ? (
          <>
            <span className={styles.wakilLabel}>
              {`${customerName?.trim().split(/\s+/)[0] ?? ""}'s Wakil`}
            </span>
            <span className={styles.ownerName}>{details?.name ?? ""}</span>
          </>
        ) : (
          details?.name
        )}
      </p>

      {!isWakil && (
        <>
          <div className={styles.addressWrapper}>
            <p className={styles.address}>
              {getAddress(
                details?.address_line_1,
                details?.address_line_2,
                details?.address_line_3,
              )}
            </p>
          </div>

          <div className={styles.additionalDetails}>
            <div className={styles.detailItem}>
              <span className={styles.detailLabel}>Country:</span>
              <span className={styles.detailValue}>{details?.country}</span>
            </div>

            <div className={styles.detailItem}>
              <span className={styles.detailLabel}>DOB:</span>
              <span className={styles.detailValue}>{details?.date_of_birth}</span>
            </div>

            <div className={styles.detailItem}>
              <span className={styles.detailLabel}>Sex:</span>
              <span className={styles.detailValue}>{details?.sex}</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CustomerDetails;
